import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agentsApi } from '../services/agentsApi';
import { toast } from 'sonner';

/**
 * Hook para deletar agente (soft delete)
 *
 * @example
 * const deleteAgent = useDeleteAgent();
 *
 * const handleDelete = async (agentId: string) => {
 *   if (confirm('Tem certeza que deseja excluir este agente?')) {
 *     try {
 *       await deleteAgent.mutateAsync(agentId);
 *     } catch (error) {
 *       // Error já tratado automaticamente
 *     }
 *   }
 * };
 */
export const useDeleteAgent = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (id) => agentsApi.delete(id),
    onSuccess: () => {
      // Invalidate queries para refetch
      queryClient.invalidateQueries({ queryKey: ['ai-agents'] });
      toast.success('Agente excluído com sucesso!');
    },
    onError: (error) => {
      toast.error(`Erro ao excluir agente: ${error.message}`);
    },
  });
};
